<template>
    <div>
        <div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <app-tabela
                idTabela="tblDocumentos"
                :itens="contrato.documentosContrato"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="botoes">
                    <div class="d-flex flex-row-reverse mb-3">
                        <btn-inserir-documento
                            :contrato="contrato"
                            :apostilamento="apostilamento()"
                            @obterDocumentosAtualizados="
                                $emit('obterDocumentosAtualizados')
                            "
                            v-if="mostrarBtnInserirDocumento"
                        ></btn-inserir-documento>
                    </div>
                </template>
                <template slot="acoes" slot-scope="data">
                    <btn-download-documento
                        :documento="data"
                    ></btn-download-documento>
                    <btn-excluir-documento
                        :documento="data"
                        :contrato="contrato"
                        :apostilamento="apostilamento()"
                        v-if="mostrarBtnExcluirDocumento"
                        @obterDocumentosAtualizados="
                            $emit('obterDocumentosAtualizados')
                        "
                    ></btn-excluir-documento>
                </template>
            </app-tabela>
        </div>
    </div>
</template>

<script>
import BtnInserirDocumento from './BtnInserirDocumento'
import BtnExcluirDocumento from './BtnExcluirDocumento'
import BtnDownloadDocumento from './BtnDownloadDocumento'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    components: {
        BtnInserirDocumento,
        BtnExcluirDocumento,
        BtnDownloadDocumento
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            documento: null,
            erros: [],
            campos: [
                {
                    key: 'tipoDocumento',
                    label: 'Tipo do Documento',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descricaoDocumento',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeArquivo',
                    label: 'Arquivo',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        apostilamento() {
            return (
                this.$temAcessoView('CONT-APOST-02') &&
                this.situacoesVigenteDistribuido()
            )
        },

        contratoElaboracao() {
            return (
                this.$temAcessoView('CONT-ELAB-00') &&
                (this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO)
            )
        },

        aditivoContratoIniciado() {
            return (
                this.$temAcessoView('CONT-ADITIV-00') &&
                (this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO)
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido() &&
                this.contrato.contratoVigente
            )
        },

        controleHistoricoAditivos() {
            return (
                this.contrato.contratoVigente ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        }
    },

    created() {},

    computed: {
        mostrarBtnInserirDocumento() {
            return (
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnExcluirDocumento() {
            return (
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        }
    },

    watch: {}
}
</script>
